/*
 * Incoming string - 'StringInPascalCase'
 * Result - 'String In Pascal Case'
 * */
export const normalizePascalCase = string => {
  return string.split(/(?=[A-Z])/).join(' ');
};

export default {};
